module.exports = __webpack_public_path__ + "packs/media/images/darum_mm_1-8f23db576c6827d20ef1b2c1f9321fcc.jpg";